import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const moduleFieldsApi = createApi({
  reducerPath: "moduleFieldsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include", // 👈 tenantId cookie/JWT
  }),
  tagTypes: ["ModuleFields"],
  endpoints: (builder) => ({
    // 🔹 GET fields for module (Add/Edit form)
    getModuleFields: builder.query({
      query: (module) => ({
        url: `/module-fields/${module}`,
        method: "GET",
      }),
      providesTags: (_res, _err, module) => [
        { type: "ModuleFields", id: module },
      ],
      keepUnusedDataFor: 300,
    }),

    // 🔹 SAVE tenant visibility
    saveModuleFieldConfig: builder.mutation({
      query: ({ module, fields }) => ({
        url: `/module-fields/${module}/config`,
        method: "POST",
        body: { fields },
      }),
      invalidatesTags: (_res, _err, { module }) => [
        { type: "ModuleFields", id: module },
      ],
    }),
  }),
});

export const {
  useGetModuleFieldsQuery,
  useSaveModuleFieldConfigMutation,
} = moduleFieldsApi;

export default moduleFieldsApi;
